if (window.innerWidth > 768) {
  document.addEventListener("DOMContentLoaded", function () {
    let isCarousel = false; // Start in Grid View
    let $mediaList = $(".product__media-list"); // Select media list

    // Ensure jQuery & Slick are available
    if (typeof jQuery === "undefined") {
      console.error(
        "jQuery is not loaded. Ensure jQuery is included in your theme."
      );
      return;
    }
    if (typeof $.fn.slick === "undefined") {
      console.error(
        "Slick Carousel is not loaded. Ensure Slick is included in your theme."
      );
      return;
    }

    // Set initial grid layout using flexbox
    $mediaList.css({
      display: "flex",
      "flex-wrap": "wrap",
    });

    // Function to initialize Slick slider
    function initCarousel(startIndex = 0) {
      console.log("Initializing Slick...");

      // ✅ Destroy Slick if already initialized before reapplying
      if ($mediaList.hasClass("slick-initialized")) {
        $mediaList.slick("unslick");
      }
      if ($(".new-thumbnail-slider").hasClass("slick-initialized")) {
        $(".new-thumbnail-slider").slick("unslick");
      }

      // ✅ Initialize Thumbnails (No Scrolling)
      $(".new-thumbnail-slider").slick({
        slidesToScroll: 1,
        asNavFor: ".product__media-list",
        focusOnSelect: false,
        infinite: false,
        arrows: false,
        variableWidth: true,
        draggable: false, // ❌ Prevent manual scrolling
        swipe: false, // ❌ Prevent swipe gestures
        touchMove: false, // ❌ Prevent touch movement
        centerMode: false,
      });

      // ✅ Initialize Main Slider
      $mediaList.slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev slick-arrow">‹</button>',
        nextArrow: '<button class="slick-next slick-arrow">›</button>',
        initialSlide: startIndex,
      });

      // Set the first thumbnail as active initially
      $(".new-thumbnail-slider .slick-slide")
        .removeClass("active")
        .eq(startIndex)
        .addClass("active");
      
      $(".new-thumbnail-slider .slick-slide").on("click", function () {
        let index = $(this).data("slickIndex");
        $mediaList.slick("slickGoTo", index);

        // Remove active class from all thumbnails and add to the clicked one
        $(".new-thumbnail-slider .slick-slide").removeClass("active");
        $(this).addClass("active");
      });

      // Update thumbnail selection when the main slider changes
      $mediaList.on("afterChange", function (event, slick, currentSlide) {
        $(".new-thumbnail-slider .slick-slide").removeClass("active");
        $(
          '.new-thumbnail-slider .slick-slide[data-slick-index="' +
            currentSlide +
            '"]'
        ).addClass("active");
      });
    }

    // Toggle carousel/grid when clicking an image
    $mediaList.on("click", "li", function (event) {
      event.preventDefault(); // Stop modal from opening

      let clickedIndex = $(this).index(); // Get the index of the clicked <li>
      console.log("Clicked item index:", clickedIndex);

      if (!isCarousel) {
        console.log("Switching to Carousel Layout");
        $mediaList.css("display", "block"); // Ensure visibility
        initCarousel(clickedIndex); // ✅ Initialize carousel without delay
        isCarousel = true; // Toggle state
        $(".toggle-grid-view").show();
        $(".new-thumbnail-slider").show();
      }
    });

    // Toggle back to grid when clicking the button
    $(document).on("click", ".toggle-grid-view", function (event) {
      event.preventDefault(); // Stop modal from opening

      if (isCarousel) {
        console.log("Switching to Grid Layout");
        $mediaList.slick("unslick").css({
          display: "flex",
          "flex-wrap": "wrap",
        });
        isCarousel = false; // Toggle state
        $(".toggle-grid-view").hide();
        $(".new-thumbnail-slider").hide();
      }
    });
  });
} else {
  $(".toggle-grid-view").hide();
  $(".new-thumbnail-slider").hide();
}
